const productsEndpoint = '/api/health/api/shop'

const getProducts = async (token: any) => {
    return await fetch(`${productsEndpoint}/products/`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`
        }
    })
}

const getCollections = async (token: any) => {
    return await fetch(`${productsEndpoint}/collections/`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`
        }
    })
}

export { getProducts, getCollections }